import React, { useState } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import ImpersonationBanner from '../ui/ImpersonationBanner';
import { ToastContainer } from '../ui/ToastNotification';
import { useNotifications } from '../../contexts/NotificationContext';

interface MainLayoutProps {
  children: React.ReactNode;
  fullHeight?: boolean;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children, fullHeight = false }) => {
  const { notifications, removeNotification } = useNotifications();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(() => {
    return localStorage.getItem('sidebarCollapsed') === 'true';
  });

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  const toggleSidebarCollapse = () => {
    const newState = !isSidebarCollapsed;
    setIsSidebarCollapsed(newState);
    localStorage.setItem('sidebarCollapsed', JSON.stringify(newState));
  };

  return (
    <div className="app-shell bg-bg-primary flex overflow-hidden">
      {/* Sidebar */}
      <Sidebar 
        isOpen={isSidebarOpen} 
        onClose={closeSidebar} 
        isCollapsed={isSidebarCollapsed}
        onToggleCollapse={toggleSidebarCollapse}
      />

      {/* Main content area */}
      <div className={`flex-1 flex flex-col min-w-0 min-h-0 transition-[margin] duration-200 ${
        isSidebarCollapsed ? 'lg:ml-[72px]' : 'lg:ml-60'
      }`}>
        {/* Impersonation Banner */}
        <ImpersonationBanner />

        {/* Header */}
        <Header onMenuClick={toggleSidebar} />

        {/* Page content */}
        <main id="main-content" className="flex-1 min-h-0 overflow-auto overscroll-contain">
          <div className={`workspace-content ${fullHeight ? 'h-full' : 'min-h-full'}`}>
            {children}
          </div>
        </main>
      </div>

      {/* Toast Notifications */}
      <ToastContainer 
        notifications={notifications.filter(n => !n.read).slice(0, 5)} 
        onClose={removeNotification} 
      />
    </div>
  );
};

export default MainLayout;
